import { createFileRoute } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { isSignInWithEmailLink, signInWithEmailLink } from 'firebase/auth';
import { auth } from '../constants/firebaseModular';
import { usePrompt } from '../hooks/usePrompt';
import { Prompt } from '../components/Prompt';
import { useNavigate } from '@tanstack/react-router';
import * as Sentry from '@sentry/browser';

type ConciergeDestination = {
  destination: string;
  apiKey: string;
  oobCode: string;
  mode: string;
  language: string;
};

export const Route = createFileRoute('/concierge')({
  validateSearch: (search: Record<string, string>): ConciergeDestination => {
    return {
      destination: search.destination,
      apiKey: search.apiKey,
      oobCode: search.oobCode,
      mode: search.mode,
      language: search.language,
    };
  },
  component: Concierge,
});

function Concierge() {
  const { destination } = Route.useSearch();
  const navigate = useNavigate();
  const { triggerPrompt } = usePrompt();
  const [email, setEmail] = useState(
    window.localStorage.getItem('emailForSignIn') ? window.localStorage.getItem('emailForSignIn') : undefined,
  );
  const handleEmailSubmit = (email: string) => {
    // SET IN STATE FOR FUNCTION CALL
    setEmail(email);

    // SET IN LOCAL STORAGE FOR CONTINUED USE
    window.localStorage.setItem('emailForSignIn', email);
  };

  useEffect(() => {
    resolveLink();
  }, []);

  useEffect(() => {
    if (email) {
      signInWithEmailLink(auth, email, window.location.href)
        .then(() => {
          // Clear email from storage.
          window.localStorage.removeItem('emailForSignIn');
          // You can access the new user via result.user
          // Additional user info profile not available via:
          // result.additionalUserInfo.profile == null
          // You can check if the user is new or existing:
          // result.additionalUserInfo.isNewUser

          // NAVIGATE TO APPROPRIATE PAGE
          navigate({ to: `../${destination}` });
        })
        .catch((error) => {
          Sentry.captureException(error);
          console.error('Error signing in with email link. Error: ', error);
          // TODO: DECIDE WHETHER TO SHOW THIS ERROR TO PATIENTS OR NOT
          alert(`Error signing in with email link. ERROR: ${error}`);
          // Some error occurred, you can inspect the code: error.code
          // Common errors could be invalid email and invalid or expired OTPs.
        });
    }
  }, [email, destination]);

  const resolveLink = async () => {
    if (isSignInWithEmailLink(auth, window.location.href)) {
      // TODO: SEND DESTINATION PARAMS AS SUGGESTED BELOW
      // https://firebase.google.com/docs/auth/web/passing-state-in-email-actions#handling_email_actions_in_a_web_application
      // Additional state parameters can also be passed via URL.
      // This can be used to continue the user's intended action before triggering

      // Get the email if available.
      if (!email) {
        // To prevent session fixation attacks, ask the user to provide the associated email.
        try {
          triggerPrompt({
            title: 'Please provide the email address associated with your account.',
            text: '',
            isInput: true,
            onSubmit: (title: string) => handleEmailSubmit(title),
          });
        } catch (error) {
          {
            Sentry.captureException(error);
            console.error('Error triggering prompt. Error: ', error);
          }
        }
      }
    }
  };
  // TODO: Handle this case
  return (
    <>
      {!email && <Prompt />}
      {/* <div>
        The page you requested should load momentarily. If it doesn't please
        reach out to your MIDEO concierge.
      </div> */}
    </>
  );
}
